import React, { useEffect } from "react";
import { connect } from "react-redux";

import styles from "./DashboardViews.module.scss";

import {
    loadDocumentAction,
} from "store/actions/Actions";

const VideoView = (props) => {
    const { task, loadDocumentAction, document } = props;

    // console.log(task);
    // console.log(document);

    useEffect(() => {
        loadDocumentAction({ id: task.subtask_data.document });
    },  [task.id, loadDocumentAction]);

    return (
        <div className={styles.video}>
            {document && document.config && document.config.document && document.config.document.url &&
              <video width="100%" style={{ maxWidth: 960 }} height="auto" autoPlay={true} controls src={document.config.document.url} />}
        </div>
    );
}

const mapStateToProps = state => ({
    document: state.DocumentReducer.document,
});

const mapDispatchToProps = {
    loadDocumentAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoView);
